export default {
  // 环境变量
  // env: {
  //   IM_ENABLE: false,
  //   ENABLE_TDE_MODULE: false,
  // },
  // UI模块
  // uiModules: [],

  // 用户信息 & 当前企业
  userInfo: {},
  enterpriseID: '',
  enterpriseInfoList: [],

  // 用户所属所有组织列表 & 当前所选组织id
  orgAllList: [],
  orgID: '',

  // 企业下能看到所有产品列表 & 当前用户所属组织能看到的产品id列表
  allProducts: [],
  privProductIDs: [],
  privProducts: [],

  // 许可证信息
  licenseInfo: {},

  // 多语言
  showLanguage: 'zh-cn',
  // 机器人列表
  robotList: {},
};



// WEBPACK FOOTER //
// ./src/store/state.js